import { createContext, useContext, useEffect, useState } from "react";
import { personaById } from "@/data/canvas";

const PersonaContext = createContext(null);

export function PersonaProvider({ children }) {
  const [personaId, setPersonaId] = useState(() => localStorage.getItem("mill_persona") || "centre_admin");

  useEffect(() => {
    localStorage.setItem("mill_persona", personaId);
  }, [personaId]);

  const persona = personaById(personaId);
  return (
    <PersonaContext.Provider value={{ personaId, setPersonaId, persona }}>
      {children}
    </PersonaContext.Provider>
  );
}

export const usePersona = () => {
  const ctx = useContext(PersonaContext);
  if (!ctx) throw new Error("usePersona must be used within PersonaProvider");
  return ctx;
};
